<app-organizer-shared-form-wrapper
  class="organizer-activity-creation-page-description"
  [activeStep]="1"
  [error$]="error$"
  [formGroup]="formGroup"
  [sectionTitle]="translateKey('section.title')"
  [sectionDescription]="translateKey('section.description')"
  [tipsConfig]="tipsConfig"
  (formSubmit)="submit($event)"
>
  <app-form-input-group
    [label]="translateKey('description.label')"
    [tips]="translateKey('description.title')"
    [errors]="descriptionErrors"
    errorKey="description"
  >
    <app-form-textarea
      #content
      formControlName="description"
      [placeholder]="translateKey('description.placeholder')"
      [rows]="10"
      [required]="true"
      [minLength]="minLength"
    >
    </app-form-textarea>
  </app-form-input-group>
</app-organizer-shared-form-wrapper>
